import { PageContainer } from '@ant-design/pro-components';
import { useQuery } from '@tanstack/react-query';
import { CSSGrid } from '@/common/components';
import { useOrganizationPath } from '@/common/hooks/use-organization-path';
import ContentSummaryCard from '../components/ContentSummaryCard';
import { queryIpCreatorContents } from '../services/ip-creator';
import { buildContentSummaryItems } from '../utils/contents';

const Contents = () => {
  const { organizationId, resolveOrganizationPath } = useOrganizationPath();
  const { data = {}, isLoading } = useQuery({
    enabled: Boolean(organizationId),
    queryFn: () => queryIpCreatorContents({ organizationId }),
    queryKey: ['ip-creator', 'contents', organizationId],
  });

  const summaryItems = buildContentSummaryItems({ data, resolveOrganizationPath });

  return (
    <PageContainer content="统计创作中生产的各种物料">
      <CSSGrid columns={{ xs: 1, sm: 2, xl: 4 }} gap="large">
        {summaryItems.map((item) => (
          <ContentSummaryCard key={item.title} item={item} loading={isLoading} />
        ))}
      </CSSGrid>
    </PageContainer>
  );
};

export default Contents;
